import type { FaireProductEntity } from "../../entity_types/product";

export const p_ays8242c6m: FaireProductEntity = {
  token: "p_ays8242c6m",
  type: "product",
  name: "8 oz Preserved Baby Eucalyptus Bundle",
  brandToken: "b_3ga4euf8eq",
  brandName: "Andaluca",
  imageUrl:
    "https://cdn.faire.com/fastly/fd927e4409a2724206c3703fdd9c0fc0fcace96ac6bc572add8de5c977cf001b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/549fe61363c448659569f99e4bb563d7762b8c162151c53135b6fed59c4edb7b.png",
    "https://cdn.faire.com/fastly/7e6edc2a93603dd6af3d178e6e197cf6de7f32a6fae9ce78278aeb8b66e93e5e.png",
  ],
  priceDollars: 13,
  description:
    'Using California grown baby eucalyptus we preserve this with glycerin (natural vegetable oil) and a touch of green dye that keeps this bundle of eucalyptus soft and fresh for up to a year! Perfect for an easy addition of styling to any room or even using in various DIY crafts from wedding bouquets to wreaths and more.\n\n• California grown and preserved baby eucalyptus\n• 28" inches in length, stems vary slightly\n• 8 ounce bundle\n• Wrapped in kraft paper',
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:13:13.973Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
